import React from 'react'
import PropTypes from 'prop-types'
import SectionHeader from 'components/SectionHeader'
import { Spacing50 } from 'styles/sharedStyle'
import PartnersCard from './PartnersCard'
import { Center, Grid, Wrapper } from './Partners.style'

const Partners = ({
  cards,
  eyebrow,
  headline,
  intro,
  enableImageFadeIn,
  villageSlug,
}) => (
  <Wrapper>
    <Center>
      <SectionHeader eyebrow={eyebrow} title={headline} content={intro} />
      {cards && cards.length && (
        <Grid count={cards.length}>
          {cards.map((card, i) => (
            <PartnersCard
              {...card}
              count={cards.length}
              key={`card${i.toString()}`}
              enableImageFadeIn={enableImageFadeIn}
              headline={headline}
              villageSlug={villageSlug}
            />
          ))}
        </Grid>
      )}
    </Center>
    <Spacing50 />
  </Wrapper>
)

Partners.propTypes = {
  cards: PropTypes.arrayOf(
    PropTypes.shape({
      altText: PropTypes.string,
      body: PropTypes.string,
      eyebrow: PropTypes.string,
      image: PropTypes.shape({
        portrait: PropTypes.shape({
          gatsbyImageData: PropTypes.shape({
            aspectRatio: PropTypes.number.isRequired,
            src: PropTypes.string.isRequired,
            srcSet: PropTypes.string.isRequired,
            srcSetWebp: PropTypes.string.isRequired,
            sizes: PropTypes.string.isRequired,
          }).isRequired,
        }),
        landscape: PropTypes.shape({
          gatsbyImageData: PropTypes.shape({
            aspectRatio: PropTypes.number.isRequired,
            src: PropTypes.string.isRequired,
            srcSet: PropTypes.string.isRequired,
            srcSetWebp: PropTypes.string.isRequired,
            sizes: PropTypes.string.isRequired,
          }).isRequired,
        }),
      }),
    })
  ),
  eyebrow: PropTypes.string,
  headline: PropTypes.string,
  intro: PropTypes.string,
  enableImageFadeIn: PropTypes.bool,
  villageSlug: PropTypes.string,
}

Partners.defaultProps = {
  cards: [],
  eyebrow: '',
  headline: '',
  intro: '',
  enableImageFadeIn: false,
  villageSlug: '',
}

export default Partners
